/* eslint-disable import/no-import-module-exports */

// Import Dependencies
import Blazy from 'blazy';
import Expandable from './ramen-imports/expandable';
import FormToggle from './ramen-imports/formtoggle';
import Pagination from './ramen-imports/pagination';
import RangeSlider from './ramen-imports/rangeslider';
import Validator from './ramen-imports/validator';
// import { FloatingGrid } from '@ramenjs/core';

// Import Styleguide components
import CardSlider from './components/CardSlider';
import Cookies from './components/Cookies';
import Countdown from './components/Countdown';
import Datetime from './components/Datetime';
import DriverCard from './components/DriverCard';
import EventSchedule from './components/EventSchedule';
import FormInputHideLabel from './components/FormInputHideLabel';
import HeroVimeo from './components/HeroVimeo';
import LogoList from './components/LogoList/LogoList';
import MultiRangeSlider from './components/MultiRangeSlider/MultiRangeSlider';
import marketoFormsUtils from './components/marketoFormsUtils';
import Navigation from './components/Navigation';
import Search from './components/Search';
import SideImages from './components/SideImages';
import SingleImageLightbox from './components/SingleImageLightbox/SingleImageLightbox';
import SubscriptionForm from './components/SubscriptionForm';
import TicketOptions from './components/TicketOptions';
import TicketSelector from './components/TicketSelector';
import TicketSelectorV2 from './components/TicketSelectorV2';
import Toggle from './components/Toggle';
import TrackMap from './components/TrackMap/TrackMap';
import TwoImages from './components/TwoImages';
import Video from './components/Video';
import VideoModal from './components/VideoModal';
import ViewportHeight from './components/ViewportHeight';

const appModules = (() => {
  // eslint-disable-next-line no-unused-vars
  const vh = new ViewportHeight();

  // Initialise Blazy
  const lazyImageInstances = new Blazy({
    selector: '.js-lazyload',
    successClass: 'is-lazyloaded',
    errorClass: 'has-load-error',
    breakpoints: [
      {
        width: 900, // max-width
        src: 'data-src-small',
      },
    ],
    offset: 600,
  });

  // Fire up lazyload for images
  lazyImageInstances.revalidate();

  CardSlider({
    selector: '.js-card-slider-container',
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    pagination: {
      el: '.js-card-slider-progressbar',
      type: 'progressbar',
    },
    a11y: true,
    revalidateLazyImages: lazyImageInstances.revalidate,
  });

  CardSlider({
    selector: '.js-card-slider-container-related',
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    a11y: true,
    revalidateLazyImages: lazyImageInstances.revalidate,
    noLightbox: true,
  });

  CardSlider({
    selector: '.js-hero-carousel-container',
    slidesPerView: '1',
    spaceBetween: 0,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.js-hero-carousel-progressbar',
      type: 'bullets',
    },
    autoplay: {
      delay: 8000,
    },
    a11y: true,
    revalidateLazyImages: lazyImageInstances.revalidate,
  });

  Cookies({
    selector: '.js-cookies',
    cta: '.js-cookies-cta',
  });

  Countdown({
    selector: '.js-countdown',
  });

  Datetime({
    selector: '.js-datetime',
  });

  DriverCard({
    selector: '.js-card--driver',
  });

  EventSchedule({
    selector: '.js-schedule-app',
  });

  Expandable({
    selector: '.js-expandable',
    button: '.js-expandable-button',
    contentPanel: '.js-expandable-content',
    openClass: 'is-open',
  });

  // Temporarily commented out until we implement a local version
  // FloatingGrid({
  //   selector: '.js-grid-floating',
  // });

  FormInputHideLabel({
    selector: '.js-hide-label',
  });

  FormToggle({
    selector: '.js-toggle',
  });

  HeroVimeo({
    selector: '.js-vimeo-player',
  });

  LogoList({
    selector: '.js-logo-listing',
    forceToAxis: true,
    mousewheel: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.js-logo-listing-progressbar',
      type: 'progressbar',
    },
    a11y: true,
  });

  MultiRangeSlider({
    selector: '.js-multi-range-slider',
    inverseLeft: '.js-inverse-left',
    inverseRight: '.js-inverse-right',
    range: '.js-range',
    inputLeft: '.js-input-left',
    inputRight: '.js-input-right',
    thumbLeft: '.js-thumb-left',
    thumbRight: '.js-thumb-right',
    valueLeft: '.js-value-left',
    valueRight: '.js-value-right',
  });

  Navigation({
    selector: '.js-nav',
    navItems: '.js-nav-item',
    navBtns: '.js-subnav-toggle',
    searchWrapper: '.js-search',
    searchBtns: '.js-search-toggle',
    searchBackBtn: '.js-nav-search-back',
    subnavWrapper: '.js-subnav-wrapper',
    subnavItems: '.js-subnav-item',
    subnavContentWrapper: '.js-subnav-content-wrapper',
    subnavItemsContentEles: '.js-subnav-item-content',
    subnavBackBtns: '.js-nav-subnav-btn',
  });

  Pagination({
    selector: '.js-pagination',
    paginationItems: '.js-pagination-link',
  });

  RangeSlider({
    selector: '.js-range-slider',
  });

  Search({
    selector: '.js-search',
    form: '.js-search-form',
    trigger: '.js-search-trigger',
    input: '.js-search-input',
    deleteBtn: '.js-search-delete',
  });

  SideImages({
    selector: '.js-side-images',
    images: '.js-side-images-image',
    sideContent: '.js-side-content',
  });

  SingleImageLightbox({
    selector: '.js-glightbox',
  });

  SubscriptionForm({
    selector: '.js-marketo-form',
    subscriptionConfirm: 'aliId',
    subscriptionConfirmMessage: '.js-subscription-confirm-message',
  });

  TicketOptions({
    selector: '.js-ticket-options',
    slider: '.js-ticket-options-selector',
    options: '.js-ticket-option',
    optionsContent: '.js-ticket-content',
    swiperSettings: {
      breakpoints: {
        600: {
          slidesPerView: 3,
        },
        900: {
          slidesPerView: 6,
          preventInteractionOnTransition: true,
        },
      },
      direction: 'horizontal',
      preventClicks: false,
      preventClicksPropagation: false,
      resistanceRatio: 0,
      slidesPerView: 2,
      threshold: 10,
    },
  });

  TicketSelector({
    selector: '.js-ticket-selector',
    filters: '.js-filters',
    options: '.js-options input',
    passes: '.js-passes',
    optionsMobile: '.js-options-mobile input',
    showFilters: '.js-show-filters',
    showFiltersWrapper: '.js-show-filters-wrapper',
    closeFilters: '.js-close-filters',
    resetFilters: '.js-reset-filters',
    breakpoint: '900px',
  });

  TicketSelectorV2({
    selector: '.js-ticket-selector-app',
  });

  Toggle({
    selector: '.js-toggle',
  });

  TrackMap({
    selector: '.js-track-map',
    ticket: '.js-track-map-ticket',
    popup: '.js-track-map-popup',
    track: '.js-track-map-track',
  });

  TwoImages({
    selector: '.js-two-images',
    imageContainer: '.js-two-images-container',
    firstImage: '.js-first-image',
    firstImageContainer: '.js-first-image-container',
    breakpoint: '900px',
  });

  Validator({
    selector: '.js-validate',
  });

  Video({
    selector: '.js-video',
    button: '.js-video-button',
  });

  VideoModal({
    selector: '.js-image-modal',
    modalButton: '.js-video-modal-button',
    closeButton: '.js-modal-close',
    modalInner: '.js-modal-inner',
    loader: '.js-modal-loader',
    modalOpen: 'is-visible',
    showOverlay: 'has-overlay',
    modalIdAttr: 'data-modal-id',
    videoIdAttr: 'data-video-id',
    videoTypeAttr: 'data-video-type',
    videoPosterAttr: 'data-video-poster',
  });

  if (document.querySelector('.mktoForm')) {
    marketoFormsUtils();
  }
})();

// Opt-in to Webpack hot module replacement
if (module.hot) module.hot.accept();

export default appModules;
